import { render } from "./CredencialContent.vue?vue&type=template&id=68ca2184"
import script from "./CredencialContent.vue?vue&type=script&lang=js"
export * from "./CredencialContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__